<template>
  <div>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(searchBooking)">
        <CModal
          :show.sync="isShow"
          :backdrop="true"
          :closeOnBackdrop="false"
          :centered="true"
          :size="'lg'"
          :color="'dark'"
          class="bclear-popup pnr-search"
        >

          <template #header-wrapper>

            <CCardHeader class="position-relative">

              <div class="d-flex ai-center">
                  <img src="~@imgPath/img/svg/icons/blue-icons/reservation-icon.svg" alt="" class="res-pop-icon">


                <div style="padding-left:15px;">
                {{ $t("cResIdSearchModal.heading") }}
                </div>
              </div>
              <div class="close"  @click="buttonList[0].func">
                <img src="@imgPath/img/svg/icons/cross-radius.svg" alt="">
              </div>
            </CCardHeader>
          </template>

          <template #body-wrapper>

            <CCardBody>
              <div class="des">{{ $t("cResIdSearchModal.desc") }} </div>
<!--              <div class="close pnr-close"  @click="buttonList[0].func" >-->
<!--                <img src="@imgPath/img/svg/icons/close.svg" />-->
<!--              </div>-->
              <div class="d-flex pnr-search-wrap">
              <div class="wrap">
                <!-- <CCol>{{ $t('cResIdSearchModal.pnr') }}</CCol> -->

                <CCol>
                  <cTextInputComponent type="text" v-model="search.pnr" :label="$t('cResIdSearchModal.pnr')" placeholder="eg., ABFEDW" />
                </CCol>
              </div>
              <!-- <br /> -->
              <div class="wrap">

                <!-- <CCol>{{ $t('cResIdSearchModal.passenger') }}</CCol> -->

<CCol>
                  <cTextInputComponent
                    type="text"
                    v-model="search.passengerName"
                    :label="$t('cResIdSearchModal.passenger')"
                    placeholder="eg., John"

                  />
</CCol>

              </div>
                 <!-- <br /> -->
              <div class="wrap">
                <!-- <CCol>{{ $t('cResIdSearchModal.reservId') }}</CCol> -->

                <CCol>
                  <cTextInputComponent
                    type="text"
                    v-model="search.reservationId"
                    :label="$t('cResIdSearchModal.reservId')"
                    placeholder="eg., MF5234"
                  />
                </CCol>
              </div>
               <CButton
                    type="submit"
                    aria-pressed="true"
                    class="btn action-c-btn btn-success m-auto curve-border"
                  >
                    <img src="@imgPath/img/svg/icons/search-icon.svg" />
                {{$t('cResIdSearchModal.search')}}
<!--                    {{buttonList[1].name}}-->
                  </CButton>
              </div>

<!--              <div class="d-flex pnr-search-wrap">-->
<!--                <div class="wrap">-->
<!--                  &lt;!&ndash; <CCol>{{ $t('cResIdSearchModal.pnr') }}</CCol> &ndash;&gt;-->

<!--                  <CCol>-->
<!--                    <cTextInputComponent type="text" v-model="search.pnr" :label="$t('cResIdSearchModal.pnr')" placeholder="eg.,10 101 0" />-->
<!--                  </CCol>-->
<!--                </div>-->
<!--                &lt;!&ndash; <br /> &ndash;&gt;-->
<!--                <div class="wrap">-->

<!--                  &lt;!&ndash; <CCol>{{ $t('cResIdSearchModal.passenger') }}</CCol> &ndash;&gt;-->

<!--                  <CCol>-->
<!--                    <cTextInputComponent-->
<!--                            type="text"-->
<!--                            v-model="search.passengerName"-->
<!--                            :label="$t('cResIdSearchModal.passenger')"-->
<!--                            placeholder="eg.,Arul"-->

<!--                    />-->
<!--                  </CCol>-->
<!--                </div>-->
<!--                &lt;!&ndash; <br /> &ndash;&gt;-->
<!--                <div class="wrap">-->
<!--                  &lt;!&ndash; <CCol>{{ $t('cResIdSearchModal.reservId') }}</CCol> &ndash;&gt;-->

<!--                  <CCol>-->
<!--                    <cTextInputComponent-->
<!--                            type="text"-->
<!--                            v-model="search.reservationId"-->
<!--                            :label="$t('cResIdSearchModal.reservId')"-->
<!--                            placeholder="eg.,A2-5K"-->
<!--                    />-->
<!--                  </CCol>-->
<!--                </div>-->
<!--                <CButton-->
<!--                        type="submit"-->
<!--                        aria-pressed="true"-->
<!--                        class="btn action-c-btn btn-success m-auto curve-border"-->
<!--                >-->
<!--                  <img src="@imgPath/img/svg/icons/search-icon.svg" />-->
<!--                  &lt;!&ndash;                    {{buttonList[1].name}}&ndash;&gt;-->
<!--                </CButton>-->
<!--              </div>           -->
            </CCardBody>
          </template>
          <template #footer-wrapper>
<!--            <CCardBody class="d-flex justify-content-end pt-0px mob-pl-pr-none pb-8px">-->
<!--              <CRow class="confirm-btn-wrapper">-->
                <!-- <CCol xl class="removewrap mb-xl-0">
                  <CButton
                    @click="buttonList[0].func"
                    aria-pressed="true"
                    class="btn action-c-btn btn-danger m-auto curve-border"
                  >
                    <img src="@imgPath/img/svg/icons/close.svg" />
                    {{buttonList[0].name}}
                  </CButton>
                </CCol> -->
                <!-- <CCol xl class="removewrap mb-xl-0">
                  <CButton
                    type="submit"
                    aria-pressed="true"
                    class="btn action-c-btn btn-success m-auto curve-border"
                  >
                    <img src="@imgPath/img/svg/icons/close.svg" />
                    {{buttonList[1].name}}
                  </CButton>
                </CCol> -->
<!--              </CRow>-->
<!--            </CCardBody>-->


            <!-- <CAlert v-if="alertValue" show color="danger">{{ alertValue }}</CAlert> -->
             <CAlert v-if="alertValue" show color="danger">
                      <div  v-if="alertValue&&alertValue.hasOwnProperty('valueList')">
                <p  v-for="(value,index) in alertValue.valueList" :key="index">
                        {{value}}
                      </p>
                      </div>
                      <div v-if="alertValue&&alertValue.hasOwnProperty('codeList')">
                      <span>{{$t("cAlert.errorCode")+' : '}}</span><span  v-for="(code,index) in alertValue.codeList" :key="index">
                        {{code +' '}}
                      </span>
                      </div>
                            <div  v-if="alertValue&&alertValue.constructor==String">
                <p  >
                        {{alertValue}}
                      </p>
                      </div>
                      </CAlert>
            <div v-if="showDataTable">
            <CCardBody v-if="resIdSearchRequest" style="padding-top: 0px;">
              <CRow >
                <CCol>
                  <cTable
                      :fields="getSearchField()"
                      :items="resIdSearchData!=null?resIdSearchData:[]"
                      :loading="resIdSearchData?false:true"
                      class="usersTable border-grey"
                      id="user-manage-table"
                      :fullScreen="false"
                  >
                  <template #action="{item}">
                  <td class="py-2">
                    <CButton @click="emitID(item)" class="btn btn-success removewrap action-c-btn ml-auto min-w-100px">{{ $t('cResIdSearchModal.select') }}</CButton>
                  </td>
                  </template>
                  <template #no-items-view>
                  <div class="text-center my-5">
                    <h3>
                     {{ $t('cResIdSearchModal.listEmpty') }}
                    </h3>
                  </div>
                </template>
                  </cTable>

                </CCol>
              </CRow>

            </CCardBody>
            </div>
          </template>
        </CModal>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import { ValidationObserver } from "vee-validate";
import { COMPONENT_NAME, PATHNAME } from "../../util/constants";
import cTextInputComponent from "../../components/form/cTextInputComponent";
import BaseConfiguration from "../../config/base";
import Logger from "../../services/logger";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../config/API_DATA";
    import cTable from "../../components/dataTable/cTable";

export default {
  name: COMPONENT_NAME.C_RESERVATION_ID_SEARCH_MODAL,

  components: {
    ValidationObserver,
    cTextInputComponent,
    cTable
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },
    resIdSearchData: {
      type: Array,
      default: []
    },
    resIdSearchRequest: {
      type: Object|Array,
      default : null
    },
    isShowDataTable : {
      type: Boolean,
      default : false
    },
    buttonList: {
      type: Array,
      default: [
        {
          name: null,
          func: {
            type: Function
          },
          color: {
            type: String,
            default: "primary"
          }
        }
      ]
    }
  },
  data() {
    return {
      search: {
        pnr: null,
        passengerName: null,
        reservationId: null
      },
      isShow: false,
      alertValue: null,
      showDataTable : false,
     // resIdSearchDataList: []
     // searchField: []
    };
  },
  methods: {
    showAlert(val) {
      this.alertValue = val;
    },

    searchBooking() {
     // this.isShow = !this.isShow;
     if(this.isValidSearch(this.search)){
       this.showAlert(null);
       this.showDataTable = true;
      this.$emit("input", this.search);
     }else{
       this.showDataTable = false;
       this.showAlert(this.$t("cResIdSearchModal.invalidSearch"))
     }
    },

    // getDataTableEmptyText(){
    //   let selField = null;
    //   let fieldValue = null;
    //   if(this.search.pnr){
    //     selField = this.$t('cResIdSearchModal.field',{field:"PNR"})
    //    // fieldValue = this.search.pnr
    //   }
    //   if(this.search.passengerName){
    //     selField = this.$t('cResIdSearchModal.field',{field:"Passenger Name"})
    //    // fieldValue = this.search.passengerName
    //   }
    //    if(this.search.reservationId){
    //     selField = this.$t('cResIdSearchModal.field',{field:this.$t('cResIdSearchModal.reservId')})
    //    // fieldValue = this.search.reservationId
    //   }
    //   return this.$t("cResIdSearchModal.listEmpty",{for:selField})

    // },

    isValidSearch(search) {
      let retValue;
        try {
          if(BaseConfiguration.isDebug) console.log("isValidSearch");
          if(search){
            if(search.pnr)
            search.pnr=search.pnr.trim();
            if(search.passengerName)
            search.passengerName=search.passengerName.trim();
            if(search.reservationId)
            search.reservationId=search.reservationId.trim();
          }
          if(search.pnr || search.passengerName || search.reservationId){
            retValue = true;
          }else{
            retValue = false;
          }
    
        } catch (err) {
                let body = Logger.buildRequest(
                 "cReservationIdSearchModal",
                  "error in isValidSearch",
                  err.toString(),
                  "isValidSearch",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
        }, 

    emitID(searchObj) {
     // this.isShow = !this.isShow;
      this.$emit("send", searchObj.reservationid);
    },

    getSearchField() {
      return [
        {
          key: "pnr",
          label: this.$t("cResIdSearchModal.pnr")
        },

        {
          key: "passengername",
          label: this.$t("cResIdSearchModal.passenger")
        },

        {
          key: "reservationid",
          label: this.$t("cResIdSearchModal.reservId")
        },
        {
          key: "bookingdate",
          label: this.$t("cResIdSearchModal.date")
        },
        {
          key: "amount",
          label: this.$t("cResIdSearchModal.amount")
        },
        {
          key: "action",
          label: this.$t("cResIdSearchModal.action")
        },
      ];
    },


    
  },
  created() {
    this.isShow = this.show;
    this.showDataTable = this.isShowDataTable;   
  }
};
</script>